import { render, staticRenderFns } from "./SlTableInfo.vue?vue&type=template&id=2ce16833&scoped=true&"
import script from "./SlTableInfo.vue?vue&type=script&lang=js&"
export * from "./SlTableInfo.vue?vue&type=script&lang=js&"
import style0 from "./SlTableInfo.vue?vue&type=style&index=0&id=2ce16833&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce16833",
  null
  
)

export default component.exports